import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useMemo } from "react";

import "./HomeLoan.css";
import Calculator from "../common/calculator";
import Banklist from "../common/Banklist/Banklist";
import LoanForm from "../common/Form/Form";
import Services from "./ServicesPages/Services";
import TestimonialsSection from "../common/testimonials-section";

const HomeLoan = () => {
  const navigate = useNavigate();
  return (
    <div>
      <section className="lap-hero">
        <div className="lap-container">
          {/* LEFT IMAGE */}
          <div className="lap-video">
            <img
              src="/images/home.png"
              alt="Financial Services"
              className="hero-video"
            />
          </div>

          {/* RIGHT CONTENT */}
          <div className="lap-content">
            <h1>
              Your Trusted Partner for
              <span> Smart Financial Solutions</span>
            </h1>

            <ul className="lap-points">
              <li>✔ Quick & Hassle-Free Loan Process</li>
              <li>✔ Competitive Interest Rates</li>
              <li>✔ Trusted Financial Guidance</li>
            </ul>

            <p>
              We help you achieve your financial goals with a wide range of loan
              solutions including Personal Loans, Home Loans, Business Loans,
              Education Loans, and Loan Against Property. Our team ensures a
              smooth process with transparent terms and flexible repayment
              options so you can focus on building your future with confidence.
            </p>
          </div>
        </div>
      </section>
      <section className="loan-usage-section">
        <div className="loan-container">
          <div className="loan-left">
            <h2>
              Turn Your Dream into Reality with a <span>Home Loan</span>
            </h2>

            <p>
              A home loan helps you purchase or build your dream home without
              worrying about large upfront payments. With flexible repayment
              options and affordable interest rates, owning a home becomes
              easier and more achievable.
            </p>

            <p>
              <strong>Krishana Finconcept Services</strong> offers trusted home
              loan solutions with quick approvals, minimal documentation, and
              competitive interest rates to help you secure your perfect home.
            </p>
          </div>

          <div className="loan-right">
            <div className="loan-card">
              <h4>Buy Your Dream Home</h4>
              <p>
                Finance the purchase of a new house or apartment with easy EMI
                options.
              </p>
            </div>

            <div className="loan-card">
              <h4>Home Construction</h4>
              <p>
                Get financial support to build your home exactly the way you
                want.
              </p>
            </div>

            <div className="loan-card">
              <h4>Home Renovation</h4>
              <p>
                Upgrade or renovate your house to improve comfort and value.
              </p>
            </div>

            <div className="loan-card">
              <h4>Balance Transfer</h4>
              <p>
                Transfer your existing home loan and enjoy lower interest rates.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="homeload-main-section homeloan-section modern-variant unique-hero-design">
        <div className="homeloan-hero-text animated-entrance">
          <div className="badge-glow animated-item">Home Finance Expert</div>

          <h1 className="title animated-item">
            Achieve Your Dream With Us <span>Home Loan!</span>
          </h1>

          <div className="features-flex animated-item">
            <div className="feat-pill">
              <span className="icon">✔</span> Customized Repayment
            </div>
            <div className="feat-pill">
              <span className="icon">✔</span> Competitive Rates
            </div>
            <div className="feat-pill">
              <span className="icon">✔</span> Expert Guidance
            </div>
          </div>

          <p className="subtitle animated-item">
            Turn your dream of owning a home into reality with our trusted Home
            Loan services. Partnered with leading banks to provide secure,
            quick, and hassle-free home financing solutions.
          </p>

          <div className="cta-wrapper animated-item">
            {/* Changed class from apply-btn to high-conversion-btn */}
            <button
              className="high-conversion-btn"
              onClick={() => {
                navigate("/services/1", { state: { scrollToApply: true } });
              }}
            >
              <span className="btn-text">Apply For Home Loan</span>
              <div className="btn-glow-shimmer"></div>
            </button>
            {/* Dynamic Background Effect */}
            <div className="dynamic-background-flow"></div>
          </div>
        </div>
      </section>

      <TestimonialsSection />

      <Services
        slug="1"
        title="Home Loan EMI Calculator – Calculate Your Monthly EMI Online
"
      />
    </div>
  );
};

export default HomeLoan;
